import { useEffect, useRef, useState } from "react";
import { useHistory, useParams } from "react-router-dom";

//datepicker
import DatePicker from "react-datepicker";
import { registerLocale } from "react-datepicker";
import es from "date-fns/locale/es";
import "react-datepicker/dist/react-datepicker.css";

//ckeditor
import { CKEditor } from "ckeditor4-react";
import { editorConfig, SwalError } from "../../../../utils/constants";

//utils
import { FileUploader } from "../../../../components/FileUploader/FileUploader";
import {
  create,
  getAll,
  getById,
  saveFile,
  update,
} from "../../../../utils/requests/dynamicReq";
import { paths } from "../../../../utils/paths";

//middleware
import moment from "moment";

import Swal from "sweetalert2";
import Axios from "axios";
import { ROUTES } from "../../../../utils/routes";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
import { useDelete } from "../../../../utils/hooks/useDelete";
import { useSelector } from "react-redux";
import { validate } from "./validations";

registerLocale("es", es);

export const ManagePress = () => {
  let { isAdmin, userRoleId } = useSelector(({ user }) => user);

  const { PRESS } = paths;
  const { id } = useParams();
  const history = useHistory();
  const { deleteIt } = useDelete();

  const [isCreate, setIsCreate] = useState(false);

  //userForm
  const [titulo, setTitulo] = useState("");
  const [date, setDate] = useState(new Date());
  const [resumen, setResumen] = useState("");
  const [medio, setMedio] = useState("");
  const [url, setUrl] = useState("");
  const [message, setMessage] = useState("");

  const [allowedEdit, setAllowedEdit] = useState(false);

  const isMounted = useRef(false);
  const source = Axios.CancelToken.source();

  useEffect(() => {
    isMounted.current = true;
    const { pathname } = history.location;
    pathname.includes("crear") ? loadDefaultData() : loadEditData();
    return () => {
      isMounted.current = false;
      source.cancel();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const loadDefaultData = async () => {
    try {
      if (isMounted.current) {
        setIsCreate(true);
        setAllowedEdit(true);
      }
    } catch (error) {
      console.log("HTTP call cancelled");
    }
  };

  const loadEditData = async () => {
    try {
      let response = await getById(PRESS, id, source);
      isMounted.current && buildObjToLoad(response);
    } catch (error) {
      console.log("HTTP call cancelled");
    }
  };

  const buildObjToLoad = async (p) => {
    const publicationDateWithOffset = new Date(p.date);
    const publicationDateNoOffset = new Date(
      publicationDateWithOffset.getTime() -
        publicationDateWithOffset.getTimezoneOffset() * -60000
    );

    setTitulo(p.titulo);

    setResumen(p.resumen);
    setMedio(p.medio);
    setUrl(p.url);

    setDate(publicationDateNoOffset);

    if (isMounted.current) setAllowedEdit(true);
  };

  //----------------------------------------

  const handleSubmit = () => {
    const press = build();
    const notValid = validate(press);
    if (notValid) {
      setMessage(notValid);
      setTimeout(() => setMessage(""), 4000);
      return;
    }
    let question = isCreate ? "crear un" : "editar este";
    Swal.fire({
      icon: "question",
      text: `¿Quieres ${question} recorte de prensa?`,
      showCancelButton: true,
      confirmButtonText: "Si",
      cancelButtonText: "No",
    }).then(({ isConfirmed }) => isConfirmed && handleConfirmation(press));
  };

  const handleConfirmation = (press) => {
    let createOrUpdate = isCreate
      ? create(PRESS, press, source)
      : update(PRESS, id, press, source);
    createOrUpdate
      .then(async ({ id: pressId }) => {
        let createOrUpdateText = isCreate ? "creado" : "editado";

        Swal.fire({
          icon: "success",
          text: `Recorte de prensa ${createOrUpdateText} correctamente.`,
        });
        history.push(`${ROUTES.Press.all}/${pressId}`);
        isMounted.current && setIsCreate(false);
      })
      .catch(() => Swal.fire({ icon: "error", text: SwalError }));
  };

  const build = () => {
    const press = {
      titulo,
      date: date ? moment(date).format("YYYY-MM-DD") : null,
      resumen,
      medio,
      url,
    };

    return press;
  };

  const editDeleteButtons = () => {
    if (isCreate) {
      return (
        <button className="baseBtn" onClick={handleSubmit}>
          Crear recorte de prensa
        </button>
      );
    }
    //if is update && logged user included as IP

    return (
      <>
        <button className="baseBtn" onClick={handleSubmit}>
          Editar recorte de prensa
        </button>
        <button
          className="smallBtn btn-danger ml-1"
          onClick={() => deleteIt(PRESS, id, ROUTES.Press.all, source)}
        >
          <FontAwesomeIcon icon={faTrash} />
        </button>
      </>
    );
  };

  return (
    <div className="centerPage">
      {(userRoleId === 1 || userRoleId === 2 || userRoleId === 3) && (
        <div className="container-fluid p-4">
          <a href="/press"> Volver a recortes de prensa</a>
          <div className="row">
            <div className="col d-flex justify-content-between">
              <div>
                <h3>Recorte de prensa </h3>
              </div>
              <div>{editDeleteButtons()}</div>
            </div>
          </div>
          <div className="row mt-4">
            <div className="col-12 text-center text-danger">
              <span>{message}</span>
            </div>
          </div>
          <div className=" form-row mt-2 ">
            <div className="col-6  d-flex flex-column  ">
              <small>*Titulo</small>
              <input
                type="text"
                className="form-control"
                placeholder="*Titulo"
                value={titulo}
                onChange={({ target: { value } }) => setTitulo(value)}
                disabled={!allowedEdit}
              />
            </div>
          </div>
          <div className="form-row mt-2">
            {" "}
            <div className="col-6  d-flex flex-column  ">
              <small>*Medio</small>
              <input
                type="text"
                className="form-control"
                placeholder="Medio"
                value={medio}
                onChange={({ target: { value } }) => setMedio(value)}
                disabled={!allowedEdit}
              />
            </div>{" "}
          </div>
          <div className="form-row mt-2">
            {" "}
            <div className="col-6  d-flex flex-column  ">
              <small>Enlace</small>
              <input
                type="text"
                className="form-control"
                placeholder="Enlace"
                value={url}
                onChange={({ target: { value } }) => setUrl(value)}
                disabled={!allowedEdit}
              />
            </div>{" "}
          </div>

          <div className="form-row mt-2">
            <div className="col">
              <small>*Fecha</small>
              <DatePicker
                className="form-control input"
                placeholderText="*Inicio"
                selected={date}
                onChange={(date) => setDate(date)}
                dateFormat="dd MMMM, yyyy"
                isClearable={allowedEdit}
                locale="es"
                disabled={!allowedEdit}
              />
            </div>
          </div>

          {(isCreate || allowedEdit) && (
            <>
              <div className="form-row mt-4">
                <div className="col">
                  <small>Resumen</small>
                  <CKEditor
                    initData={resumen}
                    config={editorConfig}
                    onChange={({ editor }) => setResumen(editor.getData())}
                    readOnly={!allowedEdit}
                  />
                </div>
              </div>
            </>
          )}
        </div>
      )}
    </div>
  );
};
